export default "__VITE_ASSET__DW6h2Q7i__"